import React from "react";
import Question from "../Components/SecondComponents/Question";
import Ads from "../Components/FirstComponents/Ads";
import Banner from "../Utils/Banner";

function Quiz() {
  return (
    <div className="w-full overflow-x-hidden">
      <div
        className="bg-contain bg-no-repeat bg-gray-200 w-full"
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <Banner title="Quiz" />

        <div className="mx-auto max-w-7xl w-full overflow-x-hidden">
          <div className="px-4 sm:px-6 lg:px-8 mt-6 sm:mt-8 mb-10">
            <Question />
            <Ads />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Quiz;
